import { useEffect, useMemo } from "react";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import useConfigurationData from "@/Common/hooks/Configuration/useConfigurationData";

interface IBranchSelectorProps {
	locationId: string;
	selectedBranch: string;
	onChange: (value: string) => void;
	className?: string;
}

const BranchSelector = ({ locationId, selectedBranch, onChange, className = "!w-[218px]" }: IBranchSelectorProps) => {
	const { configuration: data, isLoading } = useConfigurationData({ locationId });

	const branchOptions = useMemo(() => {
		const branches = data?.administrationTools?.integrations?.dmsProvider?.areaNumber ?? [];
		return branches.map((branch) => ({ label: branch, value: branch }));
	}, [data]);

	useEffect((): void => {
		const shouldAutoSelectSingleOption = branchOptions.length === 1;
		if (shouldAutoSelectSingleOption) {
			return onChange(branchOptions[0].value);
		}

		const selectedBranchIsMissing = selectedBranch && !branchOptions.map((option) => option.value).includes(selectedBranch);
		if (selectedBranchIsMissing) {
			onChange("");
		}
	}, [branchOptions]);

	const isError = branchOptions.length > 1 && !selectedBranch;
	const isDisabled = isLoading || branchOptions.length <= 1;

	return (
		<SmartSelector
			showBy="label"
			selectBy="label"
			sortBy="value"
			options={branchOptions}
			selected={selectedBranch}
			disabled={isDisabled}
			loading={isLoading}
			error={isError}
			inputProps={{
				placeholder: "Branch ID",
				classes: `[&_.MuiInputBase-root]:!py-[3px]`,
			}}
			renderTagsCustomProps={{
				classes: "!font-sans",
			}}
			onChangeAction={(selection) => onChange((selection as { value: string })?.value ?? "")}
			classes={className}
			popperProps={{ className: "!z-[1350]" } as object}
		/>
	);
};

export default BranchSelector;
